import { useHistory, useParams } from "react-router-dom"
import { BankIdSign } from "../../../../components/bankid/BankIdSign"
import React from "react"
import { useIntl } from "react-intl"
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';

import "./BankIdSignPage.scss"

const BankIdSignPage = () => {
    const intl = useIntl()
    const history = useHistory()
    const { orderId } = useParams<{ orderId: string }>()

    const [showNetworkError, setShowNetworkError] = React.useState<boolean>(false)
    const [bankIdMessage, setBankIdMessage] = React.useState<string | null>(null)

    const onBankIdError = (message: string) => {
        setShowNetworkError(true)
        setBankIdMessage(message)
    }

    return (
        <>
            <div className="BankIdSignPage-Container">
                {showNetworkError &&
                    <div className="BankIdSignPage-ErrorMessage">
                        <ReportProblemOutlinedIcon />
                        <div className="BankIdSignPage-InputErrorMessage">
                            {bankIdMessage ?? intl.formatMessage({ id: 'startIndividual.networkError' })}
                        </div>
                    </div>
                }
                <BankIdSign orderId={Number(orderId)}
                    onComplete={() => history.push('/candidate')}
                    onCancel={history.goBack}
                    onError={onBankIdError} />
            </div>
        </>
    )
}

export default BankIdSignPage